export const Layoutfun = {
  // js暂停的方法
  sleep (interval) {
    return new Promise(resolve => {
      setTimeout(resolve, interval)
    })
  },
  // eslint-disable-next-line no-unused-vars
  // 下拉框数据过多导致卡顿 封装远程搜索的方法
  ProcessingData (query = '', data, Parameter1) {
    if (query) {
      Layoutfun.sleep(150)
      // eslint-disable-next-line no-eval
      return data.filter(item => { return eval('item.' + Parameter1).toLowerCase().indexOf(query.toLowerCase()) > -1 })
    } else {
      return data.slice(0, 10)
    }
  }
}
